module.exports = __webpack_public_path__ + "static/media/Vindermere Hero Select.7a171ed8.jpg";